import { useGlobalStore } from '../../../Common/store';
import bindActions from '../../../Common/actions';
import phoneFlowReducer from '../../store/phoneFlow';

const { actions } = phoneFlowReducer;

/**
 * usePhoneFlow Custom Hook
 */
const usePhoneFlow: any = () => {
	const { state , dispatch } = useGlobalStore();

	// List of Props
	const { phoneFlow } = state;

	// List of Actions
	const {
		handleStartPasswordlessFlow 
	} = actions;

	// Bind Actions
	const phoneFlowActions = bindActions({
		handleStartPasswordlessFlow 
	}, dispatch);

	return { phoneFlow, ...phoneFlowActions };
}

export default usePhoneFlow;
